import {Nullish} from 'shared/web';

import {RentalOrderFuelTankSource} from './getRentalOrderFuelTankLevel';
import {parseFuelTankRatio} from './parseFuelTankRatio';

/**
 * @about Resolves the fuel tank level of a rental order as the raw 0–1 ratio the level
 * indicator draws: the level recorded on return, falling back to the level recorded on rent.
 * The numeric twin of `getRentalOrderFuelTankLevel`, which returns an eighth-tank label.
 */
export function getRentalOrderFuelTankRatio(
  rentalOrder: RentalOrderFuelTankSource | Nullish
): number | null {
  return parseFuelTankRatio(
    rentalOrder?.returnVehicle?.fuelTank ?? rentalOrder?.rentVehicle?.fuelTank
  );
}
